import { createReducer } from 'redux-act'

import actions from './actions'
import initialState from './initialState'
import DonateVoucherState from './types'

const openDonateVoucherModal = (state: DonateVoucherState): DonateVoucherState => ({
  ...state,
  isDonateVoucherModalOpen: true,
})
const closeDonateVoucherModal = (state: DonateVoucherState): DonateVoucherState => ({
  ...state,
  isDonateVoucherModalOpen: false,
})

const reducer = createReducer((on) => {
  on(actions.openDonateVoucherModal, openDonateVoucherModal)
  on(actions.closeDonateVoucherModal, closeDonateVoucherModal)
}, initialState)

export default reducer
